'use client';

import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { DisclosureButton } from '@headlessui/react';
import pluralize from 'pluralize';
import classNames from '@/utils/classNames';
import { ArrowDownIcon, CloseIcon } from '@/icons/solid/12';
import AttachmentsToolbarContext from '../AttachmentsToolbar.context';
import { removeAllAttachmentsAction } from '../AttachmentsToolbar.module';
import IconContainer from './IconContainer';
import type { DisclosureButtonProps } from '@headlessui/react';
const baseClassName = ['ui-not-open:rounded-lg', 'ui-open:rounded-t-lg', 'bg-stone-100', 'text-greyscale-950', 'font-semibold', 'text-normal', 'p-4', 'flex', 'items-center', 'justify-between', '*:data-[slot=label]:grow', '*:data-[slot=label]:flex', '*:data-[slot=label]:items-center', '*:data-[slot=label]:items-justify-start', '*:data-[slot=toggle-icon]:transition-transform', '*:data-[slot=toggle-icon]:transition-duration-200', '*:data-[slot=toggle-icon]:ui-not-open:rotate-180'].join(' ');
const AttachmentsToolbarHeader = t0 => {
  const $ = _c(20);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const context = useContext(AttachmentsToolbarContext);
  const allFilesUploaded = context.count.total === context.count.uploaded + context.count.failed + context.count.waiting;
  let t1;
  if ($[3] !== className) {
    t1 = classNames(baseClassName, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== allFilesUploaded || $[6] !== context.count.uploaded || $[7] !== context.count.uploading) {
    t2 = allFilesUploaded ? `Uploaded ${pluralize("item", context.count.uploaded, true)} successfully` : `Uploading ${pluralize("item", context.count.uploading, true)}`;
    $[5] = allFilesUploaded;
    $[6] = context.count.uploaded;
    $[7] = context.count.uploading;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <span data-slot="label">{t2}</span>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <IconContainer as="span" data-slot="toggle-icon"><ArrowDownIcon /></IconContainer>;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== allFilesUploaded || $[13] !== context) {
    t5 = allFilesUploaded && <IconContainer as="span" data-slot="close-icon" onClick={() => {
      context.dispatch(removeAllAttachmentsAction());
    }}><CloseIcon /></IconContainer>;
    $[12] = allFilesUploaded;
    $[13] = context;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== props || $[16] !== t1 || $[17] !== t3 || $[18] !== t5) {
    t6 = <DisclosureButton className={t1} {...props}>{t3}{t4}{t5}</DisclosureButton>;
    $[15] = props;
    $[16] = t1;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default AttachmentsToolbarHeader;